import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/http/data.service';
import { authData } from 'src/app/util/auth';
import { errorHandler } from 'src/app/util/errorHandler';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-course-exam-docket',
  templateUrl: './course-exam-docket.component.html',
  styleUrls: ['./course-exam-docket.component.scss']
})
export class CourseExamDocketComponent implements OnInit {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private dataService: DataService
  ) {}

  session = '';
  semester = '';
  sessions: string[] = [];
  semesters: string[] = [];
  notification: any = {};
  sessionAndSemester: any = {};
  _check: any;
  
  loading = false;
  skeletonLoader = true;
  downloader: any = null;

  _auth = authData();

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this._auth.Token,
    }),
  };

  ngOnInit(): void {
    this.fetchSessionAndSemester();
  }

  fetchSessionAndSemester(): Promise<any> {
    this.loading = true;
    return this.httpClient
      .get(`${environment.BASE_URL}/courses/getSessionsAndSemesters`, this.httpOptions)
      .toPromise()
      .then((res: any) => {
        this.loading = false;
        this.skeletonLoader = false;
        if (res.Success) {
          this.sessionAndSemester = res.Data;
          this.sessions = res.Data.Sessions;
          this.semesters = res.Data.Semesters;
        } else {
          this.notification = {
            message: res.Message || "An error occurred.",
            error: true,
          };
        }
      })
      .catch((error) => {
        this.loading = false;
        this.skeletonLoader = false;
        this.notification = errorHandler(error);
      });
  }

  proceedToSelection(): void {
    if (!this.session || !this.semester) {
      this.notification = {
        message: "Please select both session and semester",
        error: true
      };
      return;
    }
    
    // Clear any previous notifications
    this.notification = {};
    this.performChecks();
  }

  performChecks(): void {
    let message = "";
    this.loading = true;
    
    this.dataService
      .fetchChecks()
      .then((result) => {
        if (result.Success) {
          const {
            LateRegAppLine,
            PassportUploaded,
            AllowRegistration,
            RegistrationClosed,
            RegistrationLocked,
            OutstandingFeesName,
            StudentHasFilledBioData,
            StudentHasFilledMedicalForm,
            RequireStudentToFillMedicalForm,
            OutstandingFeesForRegistration,
            PaidLateRegistrationCollection,
            PassportPhotoRequiredForRegistration,
          } = (this._check = result.Data);

          // Check all conditions
          if (!AllowRegistration) {
            message = "Sorry, registration is not allowed at the moment";
          } else if (PassportPhotoRequiredForRegistration && !PassportUploaded) {
            message = "Please upload your passport photograph";
          } else if (RegistrationLocked) {
            message = "Your registration has been locked for this session and semester";
          } else if (RegistrationClosed) {
            message = "Registration is closed";
          } else if (LateRegAppLine && !PaidLateRegistrationCollection) {
            message = "You need to pay the late registration fee";
          } else if (OutstandingFeesForRegistration) {
            message = "Please pay your: " + OutstandingFeesName;
          } else if (!StudentHasFilledBioData) {
            message = "You haven't filled your bio-data form";
          } else if (RequireStudentToFillMedicalForm && !StudentHasFilledMedicalForm) {
            message = "You haven't filled your medical form";
          }

          if (message) {
            this.loading = false;
            this.notification = {
              message,
              error: true,
            };
          } else {
            // All checks passed, generate docket
            this.generateDocket();
          }
        } else {
          this.loading = false;
          this.notification = {
            message: result.Message || "Failed to perform checks",
            error: true,
          };
        }
      })
      .catch((error) => {
        this.loading = false;
        this.notification = errorHandler(error);
      });
  }

  generateDocket(): void {
    this.loading = true;
    this.downloader = { loading: true };

    const baseUrl = `${environment.BASE_URL}/courses/generateDocket`;
    const params = `?session=${encodeURIComponent(this.session)}&semester=${encodeURIComponent(this.semester)}`;
    const fullUrl = baseUrl + params;

    this.httpClient.get<any>(fullUrl, this.httpOptions).subscribe({
      next: (res) => {
        this.loading = false;

        if (res.Success && res.Data?.Data) {
          // Set downloader with base64 URL for HTML template to handle
          this.downloader = {
            loading: false,
            url: "data:application/pdf;base64," + res.Data.Data,
          };
          
          this.notification = {
            message: 'Exam docket generated successfully!',
            error: false
          };

        } else if (res.Success && !res.Data?.Data) {
          this.downloader = null;
          this.notification = {
            message: 'No exam docket available for the selected session and semester',
            error: true
          };
        } else {
          this.downloader = null;
          this.notification = {
            message: res.Message || 'Failed to generate exam docket',
            error: true
          };
        }
      },
      error: (error) => {
        this.loading = false;
        this.downloader = null;
        
        if (error.status === 404) {
          this.notification = {
            message: 'API endpoint not found. Please check the server configuration.',
            error: true
          };
        } else if (error.status === 401) {
          this.notification = {
            message: 'Authentication failed. Please login again.',
            error: true
          };
        } else {
          this.notification = errorHandler(error);
        }
      }
    });
  }
}